/*
description: saved data for fetching new mentions by polling 
structure: { userId: { profileId: watchId } }
 */
export const PROFILES_TO_WATCH_IDS_KEY = 'profilesToWatchIds'

/*
description: keys for product tour, boolean values indicating whether the tour has already taken place or not
structure: boolean
 */
export const REPORTS_TOUR_KEY = 'REPORTS-TOUR'
export const ALERTS_TOUR_KEY = 'ALERTS-TOUR'
export const STATISTICS_TOUR_KEY = 'STATISTICS-TOUR'
export const GI_PRODUCT_TOUR_KEY = 'GI-PRODUCT-TOUR'
export const TAGS_TOUR_KEY = 'TAGS-TOUR'
export const ADD_CONTENTS_TOUR_KEY = 'ADD-CONTENTS-TOUR'
export const GI_TOUR_PARAMETERS_TOUR_KEY = 'GI-tourParameters-TOUR'

/*
description: indicating if navigation is in multiple mode or not
structure: boolean
 */
export const NAVIGATION_PROFILES_MULTIPLE_KEY = 'NAVIGATION_PROFILES_MULTIPLE'

/*
description: saves the state of the menu to avoid change upon refresh
structure: boolean
*/
export const NAVIGATION_MENU_EXPANDED = 'NAVIGATION_MENU_EXPANDED'

/*
description: If categorization is as list indicates which dropdown is open or not by id 
structure: { categoryId: boolean }
 */
export const CATEGORIZATION_VISIBLE_FOLDERS_KEY = 'categorizationVisibleFolders'

/*
description: for storing selected active columns in table
structure: {[key: string]: array<string>}
*/
export const ACTIVE_COLUMNS_KEY = 'ACTIVE_COLUMNS'

//STATISTICS
/*
description: for storing selected widgets, this is not for saved statistics
structure: { selectedAspectIds: array<number>, computeGroups: number}
 */
export const WIDGET_SELECTION_KEY = 'WIDGET_SELECTION'

/*
description: for storing type of main chart
structure: lineChart | barChart
 */
export const SWITCHABLE_MAIN_GRAPH_KEY = 'SWITCHABLE_MAIN_GRAPH'

/*
description: indicates if some settings was changed and if modal with information was viewed
structure: undefined | changed
 */
export const STATS_INFO_MODAL_VIEWED_KEY = 'STATS_INFO_MODAL_VIEWED'

/*
description: for storing width of article listing column
structure: number
 */
export const ARTICLE_LISTING_COL_WIDTH = 'articleListingColWidth'

/*
description: indicates if the info box is displayed in the profile builder or not
structure: boolean
 */
export const PROFILE_BUILDER_INFO_BOX = 'PROFILE_BUILDER_INFO_BOX'

/*
description: Sets the timestamp for the next scheduled system downtime.
structure: boolean
 */
export const DOWNTIME_EXPIRATION_TIMESTAMP = 'DOWNTIME_EXPIRATION_TIMESTAMP'

/*
description: the last used graph style for the expanded trend view
structure: number
 */
export const TREND_EXPANDED_VIEW_GRAPH_STYLE = 'trendExpandedViewGraphStyle'